<template>
  <div class="sh-table">
    <el-table v-bind="$attrs" v-on="$listeners" ref="elTableRef">
      <template v-for="(_, name) in $slots" :slot="name">
        <slot :name="name" />
      </template>
      <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="props">
        <slot :name="name" v-bind="props" />
      </template>
    </el-table>

    <div class="page-box" :style="{ textAlign: pageAlign }" v-if="pageShow">
      <el-pagination
        ref="elPaginationRef"
        :current-page.sync="$attrs['current-page']"
        :page-size="$attrs['page-size'] || pageSize"
        :total="$attrs['total'] || total"
        :layout="$attrs['layout'] || layout"
        :page-sizes="$attrs['page-sizes'] || pageSizes"
        v-on="$listeners"
        v-bind="$attrs"
        @current-change="$listeners['page-current-change']"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShTable',
  props: {
    // 是否需要分页
    pageShow: {
      type: Boolean,
      default: true
    },
    pageAlign: {
      type: String,
      default: 'right'
    }
  },
  mounted() {
    // console.log(this.$attrs, this.$listeners)
  },
  data() {
    return {
      pageSizes: [10, 20, 50, 100, 1000],
      pageSize: 20,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 100
    }
  },
  methods: {
    getTableList() {}
  }
}
</script>

<style lang="scss" scoped>
.page-box {
  margin-top: 16px;
}
</style>
